import gql from 'graphql-tag';

export const ScoreParticipantDocument = gql`
  mutation ScoreParticipantDocument(
    $organizationId: ID!
    $participantId: ID!
    $participantDocumentId: ID!
  ) {
    scoreParticipantDocument(
      organizationId: $organizationId
      participantId: $participantId
      participantDocumentId: $participantDocumentId
    ) {
      id
      name
      state
      createdOn
      startedOn
      completedOn
      response
    }
  }
`;
